import { ActivatedRouteSnapshot } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import { allowedProductGuard, matchAppVersionProductLoadGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'games',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
            canMatch: [
                allowedProductGuard,
                (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.GAMES, route),
            ],
            canActivate: [
                (route: ActivatedRouteSnapshot) => productUnderMaintenanceGuard(route, ClientConfigProductName.CASINO, SamePathAppVersion.GAMES),
            ],
            data: { product: ClientConfigProductName.CASINO },
        },
        {
            path: 'casino',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
            canMatch: [
                allowedProductGuard,
                (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.CASINO, route),
            ],
            canActivate: [
                (route: ActivatedRouteSnapshot) => productUnderMaintenanceGuard(route, ClientConfigProductName.CASINO, SamePathAppVersion.CASINO),
            ],
            data: { product: ClientConfigProductName.CASINO },
        },
        {
            // For .de labels
            path: 'slots',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
            canMatch: [
                (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.SLOTS, route),
            ],
            canActivate: [
                (route: ActivatedRouteSnapshot) => productUnderMaintenanceGuard(route, ClientConfigProductName.CASINO, SamePathAppVersion.SLOTS),
            ],
            data: { product: ClientConfigProductName.CASINO },
        },
        {
            // For Gala-Simplification added new Route
            path: 'spins',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
            canMatch: [
                (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.SPINS, route),
            ],
            canActivate: [
                (route: ActivatedRouteSnapshot) => productUnderMaintenanceGuard(route, ClientConfigProductName.CASINO, SamePathAppVersion.SPINS),
            ],
            data: { product: ClientConfigProductName.CASINO },
        },
        {
            path: 'dice',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
            canMatch: [
                (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.DICE, route),
            ],
            canActivate: [
                (route: ActivatedRouteSnapshot) => productUnderMaintenanceGuard(route, ClientConfigProductName.CASINO, SamePathAppVersion.DICE),
            ],
            data: { product: ClientConfigProductName.CASINO },
        },
    ],
};

export default routes;
